<template>
  <div class="form">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="container">
      <div class="form-container form-container--box">
        <label for="searchBy" class="w-100 text-center mb-2">Para confirmar su identidad, por favor ingrese el código que le enviamos al correo electrónico, el que registró en el momento de realizar la solicitud.</label>
        <div class="input-wrap mb-2">
          <input v-model="code" type="text" placeholder="Código">
        </div>
        <div class="d-flex input-wrap justify-content-center">
          <button @click="veryfyCode()" class="app-btn w-100">Buscar</button>
        </div>
        <label><b> Nota: </b>Si no encuentra el correo en la bandeja de entrada por favor busque en los correos No deseados</label>

      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data(){
    return {
      code: '',
      error: '',
      loading: false
    }
  },
  computed: {
    ...mapState({
      idDocument: 'idDocument'
    }),
  },
  beforeMount(){
    if (!this.idDocument) {
      this.$router.push('consults');
      return;
    }
  },
  methods: {
    veryfyCode(){

      this.loading = true;
      
      axios.get("externos/validate/identificacion/" + this.idDocument + '/' + this.code)
      .then((result) => {

        this.loading = false;

        if (result.data == true) {

          this.loading = true;
          
          axios.get("request/SubscriptorInfo/DocumentNumber/" + this.idDocument)
          .then((result) => {
            this.loading = false;
            console.log(result.data);
            this.setRequestDataList(result.data);
            this.$router.push('/requestList');
          })
          .catch((e) => {
            this.loading = false;
            this.error = 'No se encontraron solicitudes asociadas a ese número de identificación'
          })

        }else{
          this.error = 'El código de verificación es incorrecto'
        }

      })
      .catch((e) => {
        this.loading = false;
        this.error = 'El código de verificación es incorrecto'
      })
    },
    ...mapMutations({
      setRequestDataList: 'setRequestDataList'
    }),
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;
  .container {
    // background-color: #444444;
  }
}
</style>